import React, { Component } from 'react';
import _ws from '@netuno/ws-client';
import Core from '../../Core';

import "./index.less";

export default class Properties extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: false,
      filter: "",
    };
    this.onCommand = this.onCommand.bind(this);
    this.handleChangeFilter = this.handleChangeFilter.bind(this)
  }

  onCommand = (type) => {
    Core.getContext({
      onSuccess: () => {
        const metadata = Core.data().metadata;
        let typeCode = '';
        if (metadata.remontraPrincipal__menu === 'Comprar') {
          typeCode = 'sale';
        } else if (metadata.remontraPrincipal__menu === 'Arrendar') {
          typeCode = 'rent';
        }
        // types: up, down, left, right, enter, left-page, right-page, start
        _ws.sendService({
          service: 'ws/remote/command',
          data: {
            type: JSON.stringify({
              type,
              type_code: typeCode,
              city_uid: metadata.cityUid,
              price_min: metadata.priceFrom,
              price_max: metadata.priceTo ? metadata.priceTo : 1000000000,
            })
          }
        });
      }
    });
  };

  AvoidMultipleClicks = () => {
    this.setState({ disabled: true });
    setTimeout(() => {
      this.setState({ disabled: false });
    }, 1000);
  }

  componentDidMount() {
    this.onCommand("start");
  }

  handleChangeFilter(filter) {
    if (this.state.filter !== filter) {
      this.setState({ filter })
      this.onCommand(filter)
    }
  }

  render() {
    return (
      <div className="properties">
        <div className="highlights">
          <button onClick={() => { this.onCommand("up"); this.AvoidMultipleClicks() }} disabled={this.state.disabled}>
            <img src="./icons/chevron-up.svg" alt="up" />
          </button>
          <div>
            <button onClick={() => { this.onCommand("left"); this.AvoidMultipleClicks() }} disabled={this.state.disabled}>
              <img src="./icons/chevron-left.svg" alt="left" />
            </button>
            <button onClick={() => { this.onCommand("enter"); this.AvoidMultipleClicks() }} disabled={this.state.disabled}>
              <img src="./icons/circle.svg" alt="enter" />
            </button>
            <button onClick={() => { this.onCommand("right"); this.AvoidMultipleClicks() }} disabled={this.state.disabled}>
              <img src="./icons/chevron-right.svg" alt="right" />
            </button>
          </div>
          <button onClick={() => { this.onCommand("down"); this.AvoidMultipleClicks() }} disabled={this.state.disabled}>
            <img src="./icons/chevron-down.svg" alt="down" />
          </button>
          <div className="subtitle">
            <p>Navegar nas miniaturas</p>
          </div>
        </div>

        {!this.props.isDetailsVisible && (
          <div className="pages">
            <div>
              <button onClick={() => { this.onCommand("left-page"); this.AvoidMultipleClicks() }} disabled={this.state.disabled}>
                <img src="./icons/chevron-left.svg" alt="left-page" />
              </button>
              <button onClick={() => { this.onCommand("right-page"); this.AvoidMultipleClicks() }} disabled={this.state.disabled}>
                <img src="./icons/chevron-right.svg" alt="right" />
              </button>
            </div>
            <div className="subtitle">
              <p>Navegar nas páginas</p>
            </div>
          </div>
        )}

        {!this.props.isDetailsVisible && (
          <div className="filter">
            <button onClick={() => this.handleChangeFilter("commercial")} className={this.state.filter === "commercial" ? "selected-filter" : ""}>Comercial</button>
            <button onClick={() => this.handleChangeFilter("housing")} className={this.state.filter === "housing" ? "selected-filter" : ""}>Habitação</button>
            <button onClick={() => this.handleChangeFilter("land")} className={this.state.filter === "land" ? "selected-filter" : ""}>Terreno</button>
          </div>
        )}
      </div>
    )
  }
}
